<template>
  <div>
    <div v-if="!isError">
      <v-container
        fluid
        class="d-flex"
        style="border-bottom: 1px solid #EEEEEE;"
      >
        <v-btn text @click="showPrevPage">
          <v-icon class="mr-2">mdi-arrow-left</v-icon>
          Prev Page
        </v-btn>
        <v-btn text class="mr-4" @click="showNextPage">
          Next Page
          <v-icon class="ml-2">mdi-arrow-right</v-icon>
        </v-btn>
        <v-divider vertical class="mx-4"></v-divider>
        <span class="mt-1"> Page {{ pageNum }} of {{ pageCount }} </span>
        <v-spacer></v-spacer>
        <v-btn text @click="resizeScale('plus')">
          <v-icon>mdi-magnify-plus</v-icon>
        </v-btn>
        <v-btn text @click="resizeScale('minus')">
          <v-icon>mdi-magnify-minus</v-icon>
        </v-btn>
      </v-container>
      <v-container class="d-flex justify-center mt-16">
        <v-progress-circular
          :size="100"
          :width="7"
          color="indigo"
          indeterminate
          v-show="pageLoading"
          style="margin-top: 300px;"
        ></v-progress-circular>
        <canvas
          v-show="!pageIsRendering && !pageLoading"
          id="pdf-render"
          style="border: 1px solid black; max-width: 100%;"
        ></canvas>
      </v-container>
    </div>
    <div v-else>
      <v-container class="text-center">
        <h1 class="text-uppercase mt-16 red--text">PDF not found :(</h1>
      </v-container>
    </div>
  </div>
</template>

<script>
  import pdfjsLib from "pdfjs-dist/build/pdf";
  import "pdfjs-dist/web/pdf_viewer.css";

  pdfjsLib.GlobalWorkerOptions.workerSrc =
    "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/build/pdf.worker.min.js";

  export default {
    name: "PdfViewer",
    props: {
      url: String,
    },
    data() {
      return {
        pageNum: 1,
        pageCount: 0,
        pageIsRendering: false,
        pageNumIsPending: null,
        scale: 1,
        pageLoading: true,
        pdfDoc: null,
        canvas: null,
        ctx: null,
        isError: false,
      };
    },
    methods: {
      renderPage(num) {
        this.pageIsRendering = true;

        // get page
        this.pdfDoc.getPage(num).then((page) => {
          const viewport = page.getViewport(this.scale);
          this.canvas.height = viewport.height;
          this.canvas.width = viewport.width;

          const renderCtx = {
            canvasContext: this.ctx,
            viewport,
          };
          page.render(renderCtx).promise.then(() => {
            this.pageIsRendering = false;
            this.pageLoading = false;

            if (this.pageNumIsPending !== null) {
              this.renderPage(this.pageNumIsPending);
              this.pageNumIsPending = null;
            }
          });

          // output current page
          this.pageNum = num;
        });
      },
      queueRenderPage(num) {
        if (this.pageIsRendering) this.pageNumIsPending = num;
        else this.renderPage(num);
      },
      showPrevPage() {
        if (this.pageNum <= 1) return;

        this.pageNum--;
        this.queueRenderPage(this.pageNum);
      },
      showNextPage() {
        if (this.pageNum >= this.pdfDoc.numPages) return;

        this.pageNum++;
        this.queueRenderPage(this.pageNum);
      },
      resizeScale(scaleType) {
        if (scaleType === "plus") this.scale += 0.1;
        else this.scale -= 0.1;

        this.renderPage(this.pageNum);
      },
    },
    mounted() {
      this.canvas = document.querySelector("#pdf-render");
      this.ctx = this.canvas.getContext("2d");
      // get document
      pdfjsLib
        .getDocument(this.url)
        .promise.then((pdfDoc_) => {
          this.pdfDoc = pdfDoc_;

          this.pageCount = this.pdfDoc.numPages;

          this.renderPage(this.pageNum);
        })
        .catch((err) => {
          console.log(err);
          this.isError = true;
        });
    },
  };
</script>

<style></style>
